import { type Dispatch, type SetStateAction } from 'react';
import { z } from 'zod';

export const paginationSchema = z.object({
  offset: z.number(),
  limit: z.number(),
  count: z.number(),
});

export type PageSizes = Array<number>;

export const pageSizeOptions: PageSizes = [25, 50, 100, 500, 1000];
export const searchPageSizeOptions: PageSizes = [25, 50, 100, 250];
export const maxSearchPageSize = Math.max(...searchPageSizeOptions);
// Typesense caps reachable results; offset must never exceed this.
export const maxSearchHits = 10000;

export const defaultPaginationIndex = 0;
export const defaultPaginationSize = pageSizeOptions[0];
export type PaginationState = {
  pageIndex: number;
  pageSize: number;
};

export const defaultPagination = {
  pageIndex: defaultPaginationIndex,
  pageSize: defaultPaginationSize,
};

export const auditDefaultPageSize = 100;

export type setPaginationFn = Dispatch<SetStateAction<PaginationState>>;
export type PaginationType = z.infer<typeof paginationSchema>;
